import { FootnoteReferenceV2 } from '@oneaudi/feature-app-utils';
import { Text } from '@oneaudi/unified-web-components';
import React, { Fragment, memo } from 'react';
import styled from 'styled-components';
import { useContent } from '../context/ContentContext';
import { useFeatureAppEnv } from '../context/FeatureAppEnvContext';
import { useI18n } from '../i18n';

const PriceWrapper = styled.span`
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: baseline;
  gap: 8px;
  margin-top: var(--spacing-relative-2xs);
`;

const StyledPrice = styled(Text)`
  white-space: nowrap;
`;

export type PriceProps = {
  readonly value?: number;
};

export const Price = memo(function Price({ value }: PriceProps) {
  const { 'audi-number-formatter-service': numberFormatterService } =
    useFeatureAppEnv().featureServices;
  const {
    priceFootnotes,
    priceDisplayOption: { showBasePrice, showVat },
  } = useContent();

  if (!showBasePrice || value === undefined) {
    return null;
  }

  return (
    <PriceWrapper>
      <StyledPrice
        variant={{
          order: '2',
          style: 'normal',
          type: 'copy',
        }}
        data-testid="price"
        tag="span"
      >
        {useI18n('priceFrom', { value: numberFormatterService.formatCurrency(value) })}
        {priceFootnotes?.map((footnote: string, i: number) => (
          <Fragment key={footnote}>
            {i > 0 && <sup>{', '}</sup>}
            <FootnoteReferenceV2
              footnoteId={footnote}
              footnoteAriaLabel="price"
              data-testid={`price-footnote_${i}`}
            />
          </Fragment>
        ))}
      </StyledPrice>
      {showVat && (
        <Text
          variant={{
            order: '2',
            style: 'normal',
            type: 'copy',
          }}
          tag="span"
        >
          {useI18n('vat')}
        </Text>
      )}
    </PriceWrapper>
  );
});
